import React, { Component } from 'react';
import '../../../App.css';
import '../../../styles/app-demo.css';
import MonthlyTransactions from './monthly-transactions';
import AccountsOverview from './accounts-overview';
import HomeDashboard from '../../../assets/mobile-app/home-dashboard.png';
import AppFooter from '../app-footer';

class Dashboard extends Component {

  constructor(props){
    super(props)
    this.state = {
      toggleTransactionPreview: false,
      footerUnderline: 'home'
    }
    this.toggleTransactionPreview = this.toggleTransactionPreview.bind(this);
    this.toggleNewRoute = this.toggleNewRoute.bind(this);
  }

  toggleTransactionPreview() {
    this.state.toggleTransactionPreview ?
      this.setState({
        toggleTransactionPreview: false
      })
      :
      this.setState({
        toggleTransactionPreview: true
      })
  }

  toggleNewRoute(routeName) {
    this.props.toggleNewRoute(routeName);
  }

  render() {

    return (
      <section>
        <div className="fintwist-interactive-mobile">
        <section className="mobile-app-wrapper">
          <div className="orange-header">
            <h2>Welcome {this.props.userName}</h2>
          </div>
          <div className="mobile-app-dashboard">
            <img className="dashboard-chart" src={HomeDashboard} alt={''} />
            { this.state.toggleTransactionPreview ?
              <MonthlyTransactions toggleNewRoute={this.toggleNewRoute} />
              :
              <AccountsOverview toggleNewRoute={this.toggleNewRoute} toggleTransactionPreview={this.toggleTransactionPreview} />
            }
          </div>
        </section>
        { this.state.toggleTransactionPreview ?
        <div id="hide-monthly-transactions">
          <i onClick={this.toggleTransactionPreview} className="fa fa-angle-up"></i>
        </div>
        :
        <AppFooter {...this.state} toggleNewRoute={this.toggleNewRoute} />
        }
        </div>
      </section>
    );
  }
}

export default Dashboard;
